// extracted by mini-css-extract-plugin
export default {"active":"headernav_active__tc9Nn","defaultLink":"headernav_defaultLink__7hTh9","defaultLinkActive":"headernav_defaultLinkActive__DZrBP"};